<template>
  <div class="form-group sis-input">
    <label v-if="label">
      {{ label }}
    </label>
    <tree-select
        v-model="value2"
        :multiple="multiple"
        :options="options"
        :name="name"
        :flat="flat"
        :searchable="searchable"
        @input="change_input"
        @open="open_input"
        :defaultExpandLevel="Infinity"
        :noResultsText="noresult"
        :clearable="clearable"
        :disabled="disabled"
        :deleteRemoves="deleteRemoves"
        :backspaceRemoves="backspaceRemoves"
        :placeholder="placeholder"
        :disable-branch-nodes="disable_branch_nodes"
        :match-keys="matchKeys"
        :max-height="max_height"
    />
  </div>
</template>
<script>

export default {
  props: {
    value: {
      type: [Object, String, Array, Number],
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    matchKeys : {
      type: Array,
      default: () => ['search_text']
    },
    name: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    searchable: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    options: {
      type: [Object, Array],
      default: () => []
    },
    noresult: {
      type: String,
      default: ''
    },
    max_height: {
      type: Number,
      default: 300
    },
    clear_on_select: {
      type: Boolean,
      default: true
    },
    preserveSearch: {
      type: Boolean,
      default: true
    },
    selectLabel: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    close_on_select: {
      type: Boolean,
      default: true
    },
    hide_selected: {
      type: Boolean,
      default: false
    },
    tag_placeholder: {
      type: String,
      default: 'Add this as new tag'
    },
    taggable: {
      type: Boolean,
      default: false
    },
    addTag: {
      type: Function,
      default: () => { return false }
    },
    options_limit: {
      type: Number,
      default: 100
    },
    group_values: {
      type: String,
      default: ''
    },
    group_select: {
      type: Boolean,
      default: false
    },
    group_label: {
      type: String,
      default: ''
    },
    disable_branch_nodes:{
      type: Boolean,
      default: false
    },
    flat:{
      type: Boolean,
      default: false
    },
    deleteRemoves:{
      type: Boolean,
      default: false
    },
    backspaceRemoves:{
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      value2: []
    }
  },
  watch: {
    value () {
      this.value2 = this.value
    }
  },
  mounted () {
    this.value2 = this.value
  },
  methods: {
    change_input () {
      this.$emit('input', this.value2)
    },
    open_input () {
      this.$emit('open', this.value2)
    }
  }
}

</script>
<style >

</style>
